import { render, staticRenderFns } from "./rel-receita-3-4-itens.vue?vue&type=template&id=6d38b9a9&scoped=true&"
import script from "./rel-receita-3-4-itens.vue?vue&type=script&lang=js&"
export * from "./rel-receita-3-4-itens.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-3-4-itens.vue?vue&type=style&index=0&id=6d38b9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38b9a9",
  null
  
)

export default component.exports